<script setup lang="ts">
import { computed } from 'vue';
import type { BookingProvider } from '../provider';

const props = defineProps<{
  provider: BookingProvider;
}>();

const DEFAULT_HEADING = 'Gotowe!';
const DEFAULT_TEXT =
  'Dziękujemy za rejestrację. Otrzymasz jej potwierdzenie na podany wcześniej adres e-mail. Nie rezerwuj ponownie tego samego terminu.';

const configuredHtml = computed(() => {
  const additional = window.MedfileBookingWidgetConfig?.additional;
  if (!additional) {
    return '';
  }

  const raw =
    props.provider === 'medchart'
      ? additional.medchartSuccessMessage
      : additional.successMessage;

  const trimmed = (raw || '').trim();
  if (!trimmed || !trimmed.replace(/<[^>]*>/g, '').trim()) {
    return '';
  }

  return trimmed;
});
</script>

<template>
  <div class="mbw-form-success">
    <div>
      <svg width="39" height="29" viewBox="0 0 39 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.41431 13.4142L13.4143 25.4142L37.4143 1.41422" stroke="#7CAB76" stroke-width="4" />
      </svg>
    </div>
    <div
      v-if="configuredHtml"
      class="mbw-form-success-content"
      v-html="configuredHtml"
    />
    <template v-else>
      <div class="mbw-form-success-heading">{{ DEFAULT_HEADING }}</div>
      <div class="mbw-form-success-text">{{ DEFAULT_TEXT }}</div>
    </template>
  </div>
</template>
